module.exports = __webpack_public_path__ + "static/media/discuss-a-project-button.ba9e9872.svg";